import { render, staticRenderFns } from "./OrderInfoCard.vue?vue&type=template&id=52ae28c2&"
import script from "./OrderInfoCard.vue?vue&type=script&lang=js&"
export * from "./OrderInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports